import Header from './Header';
import Nav from './Nav';

import './styles/main.scss';

interface ILayoutMainContentProps extends IChildren {
  path: string;
  isLogged: boolean;
}
function LayoutMainContent({ path, isLogged, children }: ILayoutMainContentProps) {
  return (
    <>
      <Header />
      <div className={['main-content', isLogged ? '' : 'no-logged'].join(' ')}>
        <Nav activeNav={path} />
        <div className="main-content-body">{children}</div>
      </div>
    </>
  );
}

export default LayoutMainContent;
